import lazysizes from 'lazysizes'
export default lazysizes
